export default __webpack_public_path__ + "static/media/calendar.632689d4.svg";